<div class="info-chart">
  <div class="info-chart-title" data-cy="periods-info-chart-title">{{infoChartTitle}}</div>
  @if (state.infoChartData != null) {
    <div #chartWrapper class="info-chart-wrapper">
      <canvas #periodsInfoChart class="info-chart-canvas"></canvas>
    </div>
  } @else {
    @if (hasNoResultBody) {
      <div class="chart-body-no-results">
        <div class="chart-body-no-results-wrapper">
          <img src="../../../assets/img/search/search-no-results.svg" class="chart-body-no-results-icon"/>
          <div class="chart-body-no-results-label">There are no results for your search</div>
        </div>
      </div>
    } @else {
      <div class="chart-empty">
        <div class="chart-empty-icon"><span class="iwp-icon-gen_barchart"></span></div>
        <div class="chart-empty-description" data-cy="chart-empty-description">The periods chart is empty</div>
      </div>
    }
  }
</div>



